import { render, staticRenderFns } from "./summary-report-unreturned.vue?vue&type=template&id=b9ad6860"
import script from "./summary-report-unreturned.vue?vue&type=script&lang=js"
export * from "./summary-report-unreturned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports